import { HTMLAttributes, LabelHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

export const typographyMap = {
  'bordertext-01': css`
    font-family: Barlow;
    font-size: 8px;
    line-height: 12px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 8px;
      line-height: 12px;
    }
  `,
  'bordertext-02': css`
    font-family: Barlow;
    font-size: 10px;
    line-height: 14px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 10px;
      line-height: 14px;
    }
  `,
  'bordertext-03': css`
    font-family: Barlow;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 12px;
      line-height: 16px;
    }
  `,
  'bordertext-04': css`
    font-family: Barlow;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'bordertext-05': css`
    font-family: Barlow;
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'bordertext-06': css`
    font-family: Barlow;
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'bordertext-emphasis-01': css`
    font-family: Barlow;
    font-size: 8px;
    line-height: 12px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 8px;
      line-height: 12px;
    }
  `,
  'bordertext-emphasis-02': css`
    font-family: Barlow;
    font-size: 10px;
    line-height: 14px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 10px;
      line-height: 14px;
    }
  `,
  'bordertext-emphasis-03': css`
    font-family: Barlow;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 12px;
      line-height: 16px;
    }
  `,
  'bordertext-emphasis-04': css`
    font-family: Barlow;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'bordertext-emphasis-05': css`
    font-family: Barlow;
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'bordertext-emphasis-06': css`
    font-family: Barlow;
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'content-01': css`
    font-family: Barlow;
    font-size: 8px;
    line-height: 12px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 8px;
      line-height: 12px;
    }
  `,
  'content-02': css`
    font-family: Barlow;
    font-size: 10px;
    line-height: 14px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 10px;
      line-height: 14px;
    }
  `,
  'content-03': css`
    font-family: Barlow;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 12px;
      line-height: 16px;
    }
  `,
  'content-04': css`
    font-family: Barlow;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'content-05': css`
    font-family: Barlow;
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'content-06': css`
    font-family: Barlow;
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'content-07': css`
    font-family: Barlow;
    font-size: 32px;
    line-height: 48px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'content-08': css`
    font-family: Barlow;
    font-size: 48px;
    line-height: 56px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'content-emphasis-01': css`
    font-family: Barlow;
    font-size: 8px;
    line-height: 12px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 8px;
      line-height: 12px;
    }
  `,
  'content-emphasis-02': css`
    font-family: Barlow;
    font-size: 10px;
    line-height: 14px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 10px;
      line-height: 14px;
    }
  `,
  'content-emphasis-03': css`
    font-family: Barlow;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 12px;
      line-height: 16px;
    }
  `,
  'content-emphasis-04': css`
    font-family: Barlow;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'content-emphasis-05': css`
    font-family: Barlow;
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'content-emphasis-06': css`
    font-family: Barlow;
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'content-emphasis-07': css`
    font-family: Barlow;
    font-size: 32px;
    line-height: 48px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'content-emphasis-08': css`
    font-family: Barlow;
    font-size: 48px;
    line-height: 56px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'label-01': css`
    font-family: Barlow;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 10px;
      line-height: 14px;
    }
  `,
  'label-02': css`
    font-family: Barlow;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 12px;
      line-height: 16px;
    }
  `,
  'label-03': css`
    font-family: Barlow;
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'label-04': css`
    font-family: Barlow;
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'label-05': css`
    font-family: Barlow;
    font-size: 32px;
    line-height: 48px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'label-06': css`
    font-family: Barlow;
    font-size: 48px;
    line-height: 56px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'label-07': css`
    font-family: Barlow;
    font-size: 64px;
    line-height: 72px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'label-08': css`
    font-family: Barlow;
    font-size: 80px;
    line-height: 96px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'label-required-01': css`
    font-family: Barlow;
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 10px;
      line-height: 14px;
    }
  `,
  'label-required-02': css`
    font-family: Barlow;
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 12px;
      line-height: 16px;
    }
  `,
  'label-required-03': css`
    font-family: Barlow;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  `,
  'label-required-04': css`
    font-family: Barlow;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'label-required-05': css`
    font-family: Barlow;
    font-size: 32px;
    line-height: 48px;
    font-weight: 700;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'label-required-06': css`
    font-family: Barlow;
    font-size: 48px;
    line-height: 56px;
    font-weight: 700;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'label-required-07': css`
    font-family: Barlow;
    font-size: 64px;
    line-height: 72px;
    font-weight: 700;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'label-required-08': css`
    font-family: Barlow;
    font-size: 80px;
    line-height: 96px;
    font-weight: 700;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'heading-01': css`
    font-family: Barlow;
    font-size: 32px;
    line-height: 48px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'heading-02': css`
    font-family: Barlow;
    font-size: 48px;
    line-height: 56px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'heading-03': css`
    font-family: Barlow;
    font-size: 64px;
    line-height: 72px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 28px;
    }
  `,
  'heading-04': css`
    font-family: Barlow;
    font-size: 80px;
    line-height: 96px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'heading-05': css`
    font-family: Barlow;
    font-size: 104px;
    line-height: 120px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 32px;
      line-height: 40px;
    }
  `,
  'heading-06': css`
    font-family: Barlow;
    font-size: 128px;
    line-height: 156px;
    font-weight: 400;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 32px;
      line-height: 48px;
    }
  `,
  'heading-emphasis-01': css`
    font-family: Barlow;
    font-size: 32px;
    line-height: 48px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'heading-emphasis-02': css`
    font-family: Barlow;
    font-size: 48px;
    line-height: 56px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  'heading-emphasis-03': css`
    font-family: Barlow;
    font-size: 64px;
    line-height: 72px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 28px;
    }
  `,
  'heading-emphasis-04': css`
    font-family: Barlow;
    font-size: 80px;
    line-height: 96px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  'heading-emphasis-05': css`
    font-family: Barlow;
    font-size: 104px;
    line-height: 120px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 32px;
      line-height: 40px;
    }
  `,
  'heading-emphasis-06': css`
    font-family: Barlow;
    font-size: 128px;
    line-height: 156px;
    font-weight: 600;
    letter-spacing: 0;

    @media (max-width: 767px) {
      font-size: 32px;
      line-height: 48px;
    }
  `
}

type Variant = keyof typeof typographyMap

/**
 * styled-components causes typing issues.
 * We force a type definition to fix that
 */
type ContainerProps = {
  variant: Variant
  children?: React.ReactNode
  as?: keyof JSX.IntrinsicElements
} & HTMLAttributes<HTMLSpanElement> &
  LabelHTMLAttributes<HTMLLabelElement>

export const Container: React.FC<ContainerProps> = styled.span<ContainerProps>`
  margin: 0;

  ${({ variant }) => typographyMap[variant]}
`

export { type Variant }
